import type { FeatureCollection, Geometry } from 'geojson';

import { apiClient } from '~api/client';

type InfrastructureQueryParams = {
  /** Name of the blast to query infrastructure sites for */
  blast_name: string;
  /** Buffer distance for the query */
  query_buffer?: number;
};

/** biome-ignore-start lint/style/useNamingConvention: Some types intentionally use snake_case to match API response fields */
type InfrastructureFeatureProperties = {
  ID: string | null;
  Name?: string | null;
  STRNO?: string | null;
  PLTXT?: string | null;
  Description: string;
  Source: string;
  Source_Date: number;
  Comments: string;
  Status: string | null;
  Flow_Val_1: string | null;
  Flow_Val_2: string | null;
  pipe_azimuth: number | null;
  cad_rgb: string | null;
  Diameter: string | null;
  Check_Valve: string | null;
  Label: string | null;
  Site: string;
  Shape__Length: number | null;
  last_edited_date: number | null;
  OBJECTID: number;
  GlobalID: string;
  distance: number | null;
  layer_name: string;
  site_type: string;
  source: string;
};
/** biome-ignore-end lint/style/useNamingConvention: Some types intentionally use snake_case to match API response fields */

type InfrastructureResponse = FeatureCollection<Geometry, InfrastructureFeatureProperties>;

/**
 * Infrastructure service for accessing nearby infrastructure site data based on blast name and optional buffering
 */
const infrastructureService = {
  /**
   * Get nearby infrastructure sites for a given blast, with optional buffering.
   * @param params - Query parameters for fetching infrastructure data
   * @returns Promise resolving to infrastructure GeoJSON response
   */
  getInfrastructure: async (params: InfrastructureQueryParams): Promise<InfrastructureResponse> => {
    const { blast_name, query_buffer = 350 } = params;
    const response = await apiClient.get(`/infrastructure/${encodeURIComponent(blast_name)}`, {
      params: { query_buffer, crs: 'local' },
    });
    return response.data;
  },
};

export type { InfrastructureFeatureProperties, InfrastructureQueryParams, InfrastructureResponse };
export { infrastructureService };
